import { useUserEventsByTypesStream } from '@/api';
import { BodyTemperatureIcon } from '@/Components/Common/Icons';
import { useDashboardModal } from '@/Components/Dashboard/DashboardModal';
import { unitTitleData } from '@/Components/Wellness/WellnessUtils';
import { DEVICE_UNITS, USER_MEASUREMENTS } from '@/constants/device';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { Card } from 'antd';
import { find, get } from 'lodash';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import '../RecentActivity.less';
import {
  convertTemperature,
  formatTime,
  getDateLabel,
  getRecentActivityDayWindow,
  HistoryModalTable,
  LoadingCard,
  temperatureUnits,
} from '../RecentActivityUtils';

const renderCells = (entry, { measurementSystem }) => {
  const currentSystem =
    get(entry, 'temperature_unit', DEVICE_UNITS.TEMPERATURE.C) === DEVICE_UNITS.TEMPERATURE.C
      ? USER_MEASUREMENTS.METRIC
      : USER_MEASUREMENTS.IMPERIAL;
  const temperature = convertTemperature(
    get(entry, 'temperature', '-'),
    currentSystem,
    measurementSystem
  );
  return (
    <div className="row-cell bp-cell">{`${temperature}${temperatureUnits[measurementSystem]}`}</div>
  );
};

const ModalContent = ({ useruuid, eventType, ...displayProps }) => {
  console.log('ModalContent props:', { useruuid, eventType, ...displayProps });
  const trans = useSelector(translator);
  const history = useUserEventsByTypesStream({
    useruuid,
    eventTypes: eventType,
    ...getRecentActivityDayWindow(),
  });

  return (
    <HistoryModalTable
      {...displayProps}
      {...history}
      headers={[trans('DATE_L'), trans('READING')]}
      renderCells={renderCells}
    />
  );
};

ModalContent.propTypes = {
  useruuid: PropTypes.string,
  eventType: PropTypes.string,
};

export const BiometricTemperatureCard = (props) => {
  const {
    useruuid,
    data,
    isLoading,
    timezone,
    is24HourFormat,
    locale,
    measurementSystem,
    // trendData,
  } = props;
  const trans = useSelector(translator);
  const { openDashboardModal } = useDashboardModal();

  const openHistoryModal = () =>
    openDashboardModal({
      title: (
        <div className="recent-activity-modal-title">
          <BodyTemperatureIcon
            className="recent-activity-modal-title-icon"
            hideEclipse={true}
            viewBox="15 15 30 30"
            fill="#005D98"
          />
          <span>{trans('BODYTEMPERATURE')}</span>
        </div>
      ),
      content: (
        <ModalContent
          useruuid={useruuid}
          eventType={get(data, 'eventName')}
          timezone={timezone}
          is24HourFormat={is24HourFormat}
          locale={locale}
          measurementSystem={measurementSystem}
        />
      ),
    });

  const handleCardClick = (e) => {
    e.preventDefault();
    openHistoryModal();
  };

  const handleCardKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openHistoryModal();
    }
  };

  if (isLoading) return <LoadingCard />;

  const timestamp = get(data, 'utc_timestamp_inms', '');
  const dateLabel = getDateLabel(timestamp, trans, timezone, locale);
  const formattedTime = formatTime(timestamp, is24HourFormat, timezone);
  const dataArray = get(data, 'data', []);
  const dataKey = get(unitTitleData, [measurementSystem, 'temperature'], '');
  const temperature = get(find(dataArray, ['display_label', dataKey]), 'display_value', '');
  const temperatureLabel = `${temperature} ${temperatureUnits[measurementSystem]}`;

  // const trendPercent = get(trendData, 'trendPercent', null);
  // const isUp = trendPercent > 0;
  // const isDown = trendPercent < 0;
  // const displayPercent = trendPercent !== null ? Math.abs(trendPercent) : null;

  const CardTitle = (
    <div className="recent-activity-card-header">
      <BodyTemperatureIcon
        className="recent-activity-card-icon"
        hideEclipse={true}
        viewBox="15 15 30 30"
        fill="#005D98"
      />
      <h4 className="recent-activity-card-title">{trans('BODYTEMPERATURE')}</h4>
    </div>
  );

  return (
    <Card
      className="recent-activity-card"
      onClick={handleCardClick}
      onKeyDown={handleCardKeyDown}
      role="button"
      tabIndex={0}
      hoverable
      variant="borderless"
      title={CardTitle}
    >
      <div className="recent-activity-card-body">
        <p className="recent-activity-time">
          {dateLabel} {formattedTime}
        </p>
        <p className="recent-activity-data-value">{temperatureLabel}</p>
      </div>
      {/* <>
        <hr className="recent-activity-divider" />
        <div className="recent-activity-footer-section">
          <p className="recent-activity-footer-label">{trans('READINGS_TAKEN')}</p>
          <div className="recent-activity-card-footer">
            <span className="recent-activity-comparison">
              {trans('YESTERDAY_VS_LAST_WEEK_AVG')}
            </span>
            {displayPercent !== null ? (
              <span
                className={`recent-activity-trend ${isUp ? 'up' : isDown ? 'down' : 'neutral'}`}
              >
                {isUp ? (
                  <UpArrowIcon className="trend-arrow" />
                ) : isDown ? (
                  <DownArrowIcon className="trend-arrow" />
                ) : (
                  <RightArrowIcon className="trend-arrow" />
                )}
                <span>{displayPercent}%</span>
              </span>
            ) : (
              <span className="recent-activity-trend neutral">-</span>
            )}
          </div>
        </div>
      </> */}
    </Card>
  );
};

BiometricTemperatureCard.propTypes = {
  useruuid: PropTypes.string,
  timezone: PropTypes.string,
  is24HourFormat: PropTypes.bool,
  locale: PropTypes.string,
  measurementSystem: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
  isLoading: PropTypes.bool,
  trendData: PropTypes.object,
};
